import { Mesh } from "three"

/**
 * Remember that HPBarAnchor is an Object3D
 * that contains Sprites,
 * therefor will not be affected by this.
 */
export default function enableShadows(
  mesh: unknown,
): void {
  if (mesh instanceof Mesh) {
    mesh.castShadow = true
    mesh.receiveShadow = true
  }
}
